module.exports = __webpack_public_path__ + "static/media/Frank Sinatra - Jingle Bells (Official Video).8f12611d.mp3";